import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import lottie from "lottie-web";

import AppScreen from "./AppScreen";
import ListItem from "./ListItem/ListItem";

import { FilterIcon, SortIcon, TagIcon, SearchIcon } from "./Icons";
import SortModal from "./Modals/SortModal/SortModal";
import FilterModal from "./Modals/FilterModal/FilterModal";
import TagsModal from "./Modals/TagsModal/TagsModal";
import { useHistory } from "react-router";
import { getCoursesAsync } from "../redux/coursesReducer";
import CourseSuggestion from "./CourseSuggestion/CourseSuggestion";
import TagButton from "./TagButton/TagButton";

const ListSection = (props) => {
  const dispatch = useDispatch();

  const courses = useSelector((state) => state.courses.value);
  const loading = useSelector((state) => state.courses.loading);

  let defaultConstraints = {
    name: "",
    tags: {
      AI: false,
      Android: false,
      "C#": false,
      "C++": false,
      "CS Fundamentals": false,
      "Data Science": false,
      Design: false,
      DevOps: false,
      DBMS: false,
      FrontEnd: false,
      Javascript: false,
      Java: false,
      "Machine Learning": false,
      Python: false,
      React: false,
      SQL: false,
      "UI/UX": false,
      "Web Development": false,
    },
    sort: "",
    filter: {
      cost: {
        minCost: 0,
        maxCost: 5000,
      },
      language: "",
      platform: "",
    },
  };

  let firstRender = false;
  const [constraints, setConstraints] = useState(defaultConstraints);
  const [updated, setUpdated] = useState(false);
  const [sortApplied, setSortApplied] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [tagsApplied, setTagsApplied] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    let queryString = props.location.search;

    const name = new URLSearchParams(queryString).get("name[regex]");

    const minCost = new URLSearchParams(queryString).get("cost[gte]");

    const maxCost = new URLSearchParams(queryString).get("cost[lte]");

    const sort = new URLSearchParams(queryString).get("sort");

    const tags = new URLSearchParams(queryString).get("tags[in]");

    const language = new URLSearchParams(queryString).get("language");

    const platform = new URLSearchParams(queryString).get("platform");

    let tagsArray;
    if (tags) {
      tagsArray = tags.split(",");
    }

    const tagsConstraints = {};

    if (tagsArray && tagsArray.length > 0) {
      tagsArray.forEach((item) => (tagsConstraints[item] = true));
    }

    setConstraints({
      ...constraints,
      name,
      tags: { ...constraints.tags, ...tagsConstraints },
      sort: sort || constraints.sort,
      filter: {
        ...constraints.filter,
        cost: {
          ...constraints.filter.cost,
          minCost: parseInt(minCost) || constraints.filter.cost.minCost,
          maxCost: parseInt(maxCost) || constraints.filter.cost.maxCost,
        },
        language: language || constraints.filter.language,
        platform: platform || constraints.filter.platform,
      },
    });

    //Get current page or nevermind
    const page = new URLSearchParams(queryString).get("page");

    if (page !== null) setCurrentPage(parseInt(page));

    setTimeout(() => {
      dispatch(
        getCoursesAsync(
          getSearchString(
            name,
            minCost,
            maxCost,
            sort,
            Object.keys(tagsConstraints),
            language,
            platform,
            page
          )
        )
      );
    }, 1000);

    firstRender = true;
  }, []);

  useEffect(() => {
    if (!firstRender) {
      handleSubmit(new Event("submit"));
    }
  }, [updated, currentPage]);

  useEffect(() => {
    lottie.loadAnimation({
      name: "confetti",
      container: ref.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://assets5.lottiefiles.com/packages/lf20_qujw7iit.json",
    });
  }, [loading]);

  const setSort = (input) => {
    if (input === constraints.sort) {
      setConstraints({ ...constraints, sort: defaultConstraints.sort });
    } else setConstraints({ ...constraints, sort: input });
  };

  const setMinCost = (input) => {
    // if (currentPage !== 1) setCurrentPage(1);

    if (input === constraints.filter.cost.minCost) {
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          cost: {
            ...constraints.filter.cost,
            minCost: defaultConstraints.filter.cost.minCost,
          },
        },
      });
    } else
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          cost: {
            ...constraints.filter.cost,
            minCost: parseInt(input || 0 + input),
          },
        },
      });
  };

  const ref = useRef();

  const setMaxCost = (input) => {
    // if (currentPage !== 1) setCurrentPage(1);

    if (input === constraints.filter.cost.maxCost) {
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          cost: {
            ...constraints.filter.cost,
            maxCost: defaultConstraints.filter.cost.maxCost,
          },
        },
      });
    } else
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          cost: {
            ...constraints.filter.cost,
            maxCost: parseInt(input || 0 + input),
          },
        },
      });
  };

  const setLanguage = (input) => {
    // if (currentPage !== 1) setCurrentPage(1);

    if (input === constraints.filter.language) {
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          language: defaultConstraints.filter.language,
        },
      });
    } else
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          language: input,
        },
      });
  };
  const setPlatform = (input) => {
    // if (currentPage !== 1) setCurrentPage(1);
    if (input === constraints.filter.platform) {
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          platform: defaultConstraints.filter.platform,
        },
      });
    } else
      setConstraints({
        ...constraints,
        filter: {
          ...constraints.filter,
          platform: input,
        },
      });
  };

  const setTags = (input) => {
    if (currentPage !== 1) setCurrentPage(1);
    setConstraints({
      ...constraints,
      tags: { ...constraints.tags, [input]: !constraints.tags[input] },
    });
  };

  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push(
      getSearchString(
        constraints.name,
        constraints.filter.cost.minCost,
        constraints.filter.cost.maxCost,
        constraints.sort,
        Object.keys(constraints.tags).filter(
          (item) => constraints.tags[item] === true
        ),
        constraints.filter.language,
        constraints.filter.platform,
        currentPage
      )
    );
    dispatch(
      getCoursesAsync(
        getSearchString(
          constraints.name,
          constraints.filter.cost.minCost,
          constraints.filter.cost.maxCost,
          constraints.sort,
          Object.keys(constraints.tags).filter(
            (item) => constraints.tags[item] === true
          ),
          constraints.filter.language,
          constraints.filter.platform,
          currentPage
        )
      )
    );

    constraints.sort !== defaultConstraints.sort
      ? setSortApplied(true)
      : setSortApplied(false);

    if (
      JSON.stringify(constraints.filter) !==
      JSON.stringify(defaultConstraints.filter)
    ) {
      setCurrentPage(1);
      setFilterApplied(true);
    } else {
      setFilterApplied(false);
    }

    Object.values(constraints.tags).some((item) => item === true)
      ? setTagsApplied(true)
      : setTagsApplied(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setConstraints({
      ...constraints,
      name: e.target.value,
    });
  };

  //helper function

  const getSearchString = (
    searchName = "",
    searchMinCost = 0,
    searchMaxCost = 5000,
    searchSort = "",
    searchTags = [""],
    searchLanguage = "",
    searchPlatform = "",
    searchPage = "1"
  ) => {
    let searchString = "/courses";

    const searchArray = [];

    if (searchName !== null && searchName !== "")
      searchArray.push(`name[options]=i&name[regex]=${searchName}`);

    if (searchTags !== null && searchTags.length > 0 && searchTags[0] !== "") {
      if (searchTags.length > 1)
        searchArray.push(`tags[in]=${searchTags.join(",")}`);
      else searchArray.push(`tags[in]=${searchTags[0]}`);
    }

    if (searchMinCost !== null && searchMinCost !== 0)
      searchArray.push(`cost[gte]=${searchMinCost}`);

    if (searchMaxCost !== null && searchMaxCost !== 5000)
      searchArray.push(`cost[lte]=${searchMaxCost}`);

    if (searchSort !== null && searchSort !== "")
      searchArray.push(`sort=${searchSort}`);

    if (searchLanguage !== null && searchLanguage !== "")
      searchArray.push(`language=${searchLanguage}`);

    if (searchPlatform !== null && searchPlatform !== "")
      searchArray.push(`platform=${searchPlatform}`);

    if (searchPage !== null && searchPage !== "")
      searchArray.push(`page=${searchPage}`);

    return searchString + "?" + searchArray.join("&");
  };

  return (
    <AppScreen>
      <div className="px-4 pt-28 md:px-14 pb-10">
        <div className="col-span-4 grid gap-4">
          <div className="w-full bg-white rounded-md row-span-1 p-5 shadow-lg transition-all duration-1000">
            <div className="flex flex-col sm:flex-row justify-between">
              <form
                className="flex flex-col sm:flex-row justify-between items-center w-full sm:w-auto"
                onSubmit={(e) => handleSubmit(e)}
              >
                <div className="flex items-center w-full sm:w-auto">
                  <button type="submit" className="text-2xl px-2">
                    <SearchIcon />
                  </button>
                  <input
                    name="search"
                    placeholder="Course Search"
                    type="text"
                    className="font-semibold sm:text-lg outline-none border-b-2 border-gray-300 rounded-t-md p-2 w-full sm:w-auto"
                    value={constraints.name || ""}
                    onChange={(e) => handleSearch(e)}
                  />
                </div>
              </form>
              <form
                className="flex flex-col sm:flex-row justify-between items-center w-full sm:w-auto"
                onSubmit={(e) => handleSubmit(e)}
              >
                <div className="flex gap-3 mt-6 xs:mt-0">
                  <div
                    className="flex items-center px-2 py-1 rounded-md gap-4 bg-transparent sm:relative"
                    id="sortConstraintButton"
                    tabIndex={0}
                  >
                    <p className="text pb-px"> Sort</p>
                    <SortIcon />
                    <SortModal value={constraints.sort} setSort={setSort} />
                  </div>
                  <div
                    className="flex items-center px-2 py-1 rounded-md gap-4 bg-transparent sm:relative"
                    id="filterConstraintButton"
                    tabIndex={0}
                  >
                    <p className="text pb-px">Filter</p>
                    <FilterIcon />
                    <FilterModal
                      minCost={constraints.filter.cost.minCost}
                      maxCost={constraints.filter.cost.maxCost}
                      language={constraints.filter.language}
                      platform={constraints.filter.platform}
                      setMinCost={setMinCost}
                      setMaxCost={setMaxCost}
                      setLanguage={setLanguage}
                      setPlatform={setPlatform}
                      handleSubmit={handleSubmit}
                    />
                  </div>
                  <div
                    className="flex items-center px-2 py-1 rounded-md gap-4 bg-transparent sm:relative"
                    id="tagsConstraintButton"
                    tabIndex={0}
                  >
                    <p className="text pb-px">Tags</p>
                    <TagIcon />
                    <TagsModal tags={constraints.tags} setTags={setTags} />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="p-5 bg-white h-auto rounded-md grid gap-x-10 gap-y-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 shadow-lg">
            {loading && (
              <span
                className="col-span-full h-10 flex justify-center"
                ref={ref}
              />
            )}
            {courses.count !== undefined && courses.count === 0 && !loading && (
              <p className=" md:ml-5 text-center md:text-left font-medium col-span-full">
                No courses found, please try changing the search words.
              </p>
            )}
            {courses.data && courses.count !== 0 && !loading && (
              <p className=" md:ml-5 md:mt-3 text-center md:text-left font-medium col-span-full">
                Found {courses.count} course
                {courses.count > 1 && "s"}
              </p>
            )}

            {/* removable tags */}
            {(tagsApplied || sortApplied || filterApplied) && (
              <div className="col-span-full flex gap-4 md:ml-5">
                {tagsApplied && (
                  <div className="flex gap-4 flex-wrap">
                    {Object.keys(constraints.tags)
                      .filter((item) => constraints.tags[item] === true)
                      .map((item) => (
                        <TagButton
                          key={item}
                          tag={item}
                          handleClick={() => {
                            setTags(item);
                            setUpdated(!updated);
                          }}
                          removable
                        />
                      ))}
                  </div>
                )}
                {filterApplied && (
                  <div className="flex gap-4 flex-wrap">
                    {constraints.filter.cost.minCost !== 0 && (
                      <TagButton
                        tag={constraints.filter.cost.minCost}
                        handleClick={() => {
                          setMinCost(0);
                          setUpdated(!updated);
                        }}
                        removable
                      />
                    )}
                    {constraints.filter.cost.maxCost !== 5000 && (
                      <TagButton
                        tag={constraints.filter.cost.maxCost}
                        handleClick={() => {
                          setMaxCost(0);
                          setUpdated(!updated);
                        }}
                        removable
                      />
                    )}
                    {constraints.filter.language !== "" && (
                      <TagButton
                        tag={constraints.filter.language}
                        handleClick={() => {
                          setLanguage(constraints.filter.language);
                          setUpdated(!updated);
                        }}
                        removable
                      />
                    )}
                    {constraints.filter.platform !== "" && (
                      <TagButton
                        tag={constraints.filter.platform}
                        handleClick={() => {
                          setPlatform(constraints.filter.platform);
                          setUpdated(!updated);
                        }}
                        removable
                      />
                    )}
                  </div>
                )}
                {sortApplied && (
                  <div className="flex gap-4 flex-wrap">
                    {constraints.sort !== "" && (
                      <TagButton
                        tag={constraints.sort}
                        handleClick={() => {
                          setSort(constraints.sort);
                          setUpdated(!updated);
                        }}
                        removable
                      />
                    )}
                  </div>
                )}
              </div>
            )}
            {loading && (
              <>
                <ListItem />
                <ListItem />
                <ListItem />
                <ListItem />
              </>
            )}
            {courses.data &&
              courses.data.map((item) => (
                <ListItem
                  key={item._id}
                  title={item.name}
                  rating={item.rating}
                  by={item.platform}
                  tags={item.tags}
                  cost={item.cost}
                  courseID={item._id}
                  thumbnail={item.thumbnail}
                  setTags={setTags}
                />
              ))}

            {/* kya add karna hai? button! only when >= 12   */}

            {courses && courses.count > 12 && (
              <div className="col-span-full flex justify-center items-center my-10">
                <span className="bg-white p-2 shadow-lg rounded-md">
                  {new Array(Math.ceil(courses.count / 12))
                    .fill(0)
                    .map((item, index) => (
                      <button
                        onClick={(e) => {
                          document.documentElement.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                          setCurrentPage(index + 1);
                        }}
                        className={`mx-2 text-indigo-500 ${
                          currentPage === index + 1 &&
                          "font-bold text-indigo-600 pointer-events-none"
                        }`}
                      >
                        {index + 1}
                      </button>
                    ))}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <CourseSuggestion />
    </AppScreen>
  );
};

export default ListSection;
